export default __webpack_public_path__ + "static/logo-icon-fd27eea0f248f2c8a2f3fa763a979a2e.png";